export enum Tax {
  VAT = 'VAT',
  NOVA = 'NOVA',
  REGISTRATION = 'REGISTRATION',
  REGISTRATION_RELATIVE = 'REGISTRATION_RELATIVE',
  ECOMALUS = 'ECOMALUS',
  TRANSCRIPTION = 'TRANSCRIPTION',
  ECO = 'ECO',
  REGION = 'REGION',
  CIVIL = 'CIVIL',
  EXCISE = 'EXCISE',
  AUTHENTICATION = 'AUTHENTICATION',
  PROPERTY_ACQUISITION = 'PROPERTY_ACQUISITION',
  WEIGHT = 'WEIGHT',
  CO2 = 'CO2',
  EMISSION_CLASS = 'EMISSION_CLASS',
  RESIDUAL_VALUE = 'RESIDUAL_VALUE',
  AUTOMOBILSTEUER = 'AUTOMOBILSTEUER',
  AGE_DISCOUNT = 'AGE_DISCOUNT',
  GROSS_BPM = 'GROSS_BPM',
}
